import { ReactNode } from 'react';
import { Icon, type ValidIcons } from '@kizen/kds/Icon';
import { Spacer } from '@kizen/kds/Spacer';
import { Typography } from '@kizen/kds/Typography';
import { ContentCard } from '../../styles';

type UsageSectionProps = {
  icon: ValidIcons;
  title: string;
  action?: ReactNode;
  qaId: string;
  children: ReactNode;
};

export const UsageSection = ({
  icon,
  title,
  action,
  qaId,
  children,
}: UsageSectionProps) => {
  return (
    <ContentCard data-qa-id={qaId}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-x-10">
          <Icon icon={icon} size="lg" tooltipEnabled={false} />
          <Typography variant="header" size="base" weight="semibold">
            {title}
          </Typography>
        </div>
        {action ?? null}
      </div>
      <Spacer size={20} />
      {children}
    </ContentCard>
  );
};
